import React, { FC } from 'react';
import { Link } from '@components/Link';
import { Routes } from '../../../../router';

export interface INamePatientsFormatterFormatterProps {
  patients: {
    id: string;
    name: string;
    surname: string;
  };
}

export const namePatientsFormatter: FC<INamePatientsFormatterFormatterProps> = ({ patients }) => (
  <Link
    key={patients.id}
    variant="primary"
    to={`${Routes.Patients}/${patients.id}`}
    label={`${patients.name} ${patients.surname}`}
  />
);
